import {computed, defineComponent, ref, watch} from "vue";
import {type IProcessCounterData, ProcessCounterType} from "@/app/stores/monitoring-store.ts";
import {AdminProcessDetail} from "@/app/admin/admin-routes.ts";

const PROCESS_TYPE_ROUTE_PARAMS = {
    [ProcessCounterType.SessionsWithoutInvoice]: 'without-invoice'
} as const;


export default defineComponent({
    props: {
        counter: {
            type: Object as () => IProcessCounterData,
            required: true
        }
    },
    setup(props) {
        const processCounterLoading = ref<boolean>(true);
        const processCounter = ref<number>(0);
        const processCounterText = ref<string>();
        
        const processCounterCssClass = (counter: number) => {
            return counter > 0 ? 'alert' : 'success';
        };

        const routeDetail = (processCounterType: ProcessCounterType) => {
            return {
                name: AdminProcessDetail.name,
                params: { type: PROCESS_TYPE_ROUTE_PARAMS[processCounterType] }
            };
        }
        
        const processDetailType = computed(() => {
            return 'without-invoice';
        })

        const processCounterIcon = (counter: number) => {
            return counter > 0 ? 'alert-circle' : 'check-circle';
        };

        const counterChanged = async (processCounterData: IProcessCounterData) => {
            processCounterLoading.value = true;
            processCounterText.value = processCounterData.counterText;
            processCounter.value = processCounterData.counter;
            processCounterLoading.value = false;
        };

        watch(() => props.counter, counterChanged, {immediate: true, deep: true});

        return {
            adminProcessDetailRouteName: AdminProcessDetail.name,
            processDetailType,
            processCounterLoading,
            processCounterText,
            processCounter,
            processCounterCssClass,
            processCounterIcon,
            routeDetail
        };
    }
});
